module.exports = __webpack_public_path__ + "img/GCC_Proposed-scheme.e3e63a4e.jpg";